import { z } from "zod";

/* ===========================================================================
 * US-E6.F6-0044 — Manual Reminder (@UC0041)
 * POST /v1/collections/:id/reminders — nhắc member chưa đóng (unpaid/overdue).
 * Enqueue outbox `reminder` + notification `in_app` (KHÔNG push thật — defer P8.5).
 * KHÔNG post ledger.
 * ========================================================================= */

/** Body: chọn 1 phần member để nhắc (vắng = tất cả due chưa đóng). */
export const sendRemindersRequestSchema = z
  .object({
    groupMemberIds: z.array(z.string().uuid()).max(500).optional(),
  })
  .strict();

export type SendRemindersRequest = z.infer<typeof sendRemindersRequestSchema>;

export const sendRemindersResponseSchema = z
  .object({
    remindedCount: z.number().int().nonnegative(),
  })
  .strict();

export type SendRemindersResponse = z.infer<
  typeof sendRemindersResponseSchema
>;
